{
  "familyId": "TAA-LEZEN-DETAIL",
  "questions": [
    {
      "id": "TAA-LEZEN-DETAIL-001",
      "familyId": "TAA-LEZEN-DETAIL",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tekstbegrip",
      "subSkill": "tekst_detail",
      "questionType": "multiple_choice",
      "question": "Hoe hoog is de Eiffeltoren?",
      "options": ["330 meter", "1889 meter", "6 miljoen meter", "300 meter"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "data": {
            "passage": "De Eiffeltoren staat in Parijs. Hij is 330 meter hoog en werd gebouwd in 1889. Elk jaar bezoeken meer dan 6 miljoen mensen de toren.",
            "instruction": "Lees de tekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Detailvragen beantwoorden",
            "content": "Bij een detailvraag zoek je het exacte antwoord in de tekst. Zoek het sleutelwoord uit de vraag ('hoog') en lees de zin waar dat woord in staat.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "detail_getal_aflezen",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De Eiffeltoren is 330 meter hoog. Dit staat letterlijk in de tekst: 'Hij is 330 meter hoog'. Bij detailvragen zoek je het exacte antwoord in de tekst.",
        "solutionSteps": [
          "Lees de vraag: hoe hoog?",
          "Zoek in de tekst naar informatie over hoogte",
          "'Hij is 330 meter hoog' → antwoord: 330 meter"
        ],
        "distractorExplanations": {
          "0": "Goed! 330 meter staat letterlijk in de tekst.",
          "1": "Je dacht waarschijnlijk dat 1889 het antwoord is. Maar 1889 is het bouwjaar, niet de hoogte. Onthoud: lees goed welk getal bij welke informatie hoort.",
          "2": "Je dacht waarschijnlijk dat 6 miljoen het antwoord is. Maar 6 miljoen is het aantal bezoekers per jaar, niet de hoogte. Onthoud: koppel elk getal aan de juiste informatie.",
          "3": "Je dacht waarschijnlijk dat het 300 meter is. Maar de tekst zegt 330 meter. Onthoud: lees het getal precies — één cijfer verschil maakt het antwoord fout."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.wrong-number-from-text", "label": "Verkeerd getal uit tekst gekozen (bouwjaar)", "optionIndex": 1 },
          { "id": "taa.wrong-number-from-text", "label": "Verkeerd getal uit tekst gekozen (bezoekers)", "optionIndex": 2 },
          { "id": "taa.imprecise-reading", "label": "Getal onnauwkeurig gelezen (300 i.p.v. 330)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-LEZEN-DETAIL-002",
      "familyId": "TAA-LEZEN-DETAIL",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tekstbegrip",
      "subSkill": "tekst_detail",
      "questionType": "multiple_choice",
      "question": "Waardoor ademen dolfijnen?",
      "options": ["Door een blaasgat bovenop hun hoofd", "Door kieuwen", "Door hun mond", "Door hun neus"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "data": {
            "passage": "Dolfijnen zijn zoogdieren die in de zee leven. Ze ademen door een blaasgat bovenop hun hoofd. Dolfijnen leven in groepen die scholen worden genoemd.",
            "instruction": "Lees de tekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Zoek het sleutelwoord",
            "content": "Zoek het sleutelwoord uit de vraag ('ademen') in de tekst. Lees de zin waar dat woord staat: 'Ze ademen door een blaasgat bovenop hun hoofd.'",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "detail_specifiek_feit",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Dolfijnen ademen door een blaasgat bovenop hun hoofd. Dit staat letterlijk in de tekst. Dolfijnen zijn zoogdieren, geen vissen, dus ze hebben geen kieuwen.",
        "solutionSteps": [
          "Zoek in de tekst naar informatie over ademen",
          "'Ze ademen door een blaasgat bovenop hun hoofd'",
          "Antwoord: door een blaasgat"
        ],
        "distractorExplanations": {
          "0": "Goed! De tekst zegt: 'Ze ademen door een blaasgat bovenop hun hoofd.'",
          "1": "Je dacht waarschijnlijk aan kieuwen. Maar kieuwen hebben vissen, niet dolfijnen. Dolfijnen zijn zoogdieren. Onthoud: zoek het antwoord in de tekst, niet in je eigen kennis.",
          "2": "Je dacht waarschijnlijk dat dolfijnen door hun mond ademen. Maar de tekst zegt specifiek 'blaasgat'. Onthoud: gebruik de exacte informatie uit de tekst.",
          "3": "Je dacht waarschijnlijk dat het blaasgat een soort neus is. Maar de tekst noemt het specifiek een 'blaasgat', niet een neus. Onthoud: gebruik het woord dat in de tekst staat."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.outside-knowledge", "label": "Eigen kennis invullen (kieuwen bij vissen)", "optionIndex": 1 },
          { "id": "taa.imprecise-reading", "label": "Tekst onnauwkeurig gelezen (mond i.p.v. blaasgat)", "optionIndex": 2 },
          { "id": "taa.synonym-confusion", "label": "Blaasgat verward met neus", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-LEZEN-DETAIL-003",
      "familyId": "TAA-LEZEN-DETAIL",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tekstbegrip",
      "subSkill": "tekst_detail",
      "questionType": "multiple_choice",
      "question": "Wanneer regent het het meest in Nederland?",
      "options": ["In oktober en november", "In de zomer", "Het hele jaar evenveel", "In december en januari"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "data": {
            "passage": "In Nederland regent het gemiddeld 800 mm per jaar. De meeste regen valt in oktober en november. In de zomer regent het minder, maar de buien zijn vaak heviger.",
            "instruction": "Lees de tekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afleidende informatie herkennen",
            "content": "Soms staan er extra details in de tekst die je kunnen afleiden. 'Heviger' klinkt als 'meer', maar heviger buien ≠ meer regen. Lees precies wat er staat.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "detail_afleidende_info",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De meeste regen valt in oktober en november. Dit staat letterlijk in de tekst. Let op: in de zomer regent het minder, maar de buien zijn heviger — dat is iets anders dan 'het meest'.",
        "solutionSteps": [
          "Zoek in de tekst naar 'meeste regen'",
          "'De meeste regen valt in oktober en november'",
          "Antwoord: oktober en november"
        ],
        "distractorExplanations": {
          "0": "Goed! De tekst zegt: 'De meeste regen valt in oktober en november.'",
          "1": "Je dacht waarschijnlijk dat het in de zomer het meest regent. Maar de tekst zegt dat het in de zomer MINDER regent, alleen de buien zijn heviger. Onthoud: heviger ≠ meer.",
          "2": "Je dacht waarschijnlijk dat het het hele jaar evenveel regent. Maar de tekst zegt juist dat oktober en november de meeste regen hebben. Onthoud: zoek het exacte antwoord in de tekst.",
          "3": "Je dacht waarschijnlijk aan december en januari. Maar die maanden worden niet genoemd als regenmaanden. Onthoud: kies alleen een antwoord dat in de tekst staat."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.misleading-detail", "label": "Afleidende informatie (heviger = meer)", "optionIndex": 1 },
          { "id": "taa.answer-not-in-text", "label": "Antwoord niet in tekst (het hele jaar evenveel)", "optionIndex": 2 },
          { "id": "taa.answer-not-in-text", "label": "Antwoord niet in tekst (december/januari)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-LEZEN-DETAIL-004",
      "familyId": "TAA-LEZEN-DETAIL",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tekstbegrip",
      "subSkill": "tekst_detail",
      "questionType": "multiple_choice",
      "question": "Waar begonnen de moderne Olympische Spelen?",
      "options": ["In Athene", "In het oude Griekenland", "In 776 voor Christus", "Om de vier jaar"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "data": {
            "passage": "De eerste Olympische Spelen werden gehouden in het oude Griekenland, in 776 voor Christus. De moderne Spelen begonnen in 1896 in Athene. Tegenwoordig worden ze om de vier jaar gehouden.",
            "instruction": "Lees de tekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Precies lezen",
            "content": "Let op het verschil tussen 'eerste' en 'moderne'. De vraag gaat over de MODERNE Spelen. Zoek dat woord in de tekst en lees die zin nauwkeurig.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "detail_onderscheid_maken",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De moderne Olympische Spelen begonnen in Athene (1896). Let op het verschil: de EERSTE Spelen waren in het oude Griekenland (776 v.Chr.), de MODERNE Spelen begonnen in Athene.",
        "solutionSteps": [
          "De vraag gaat over de MODERNE Spelen",
          "Zoek in de tekst: 'De moderne Spelen begonnen in 1896 in Athene'",
          "Antwoord: Athene"
        ],
        "distractorExplanations": {
          "0": "Goed! De moderne Spelen begonnen in 1896 in Athene.",
          "1": "Je dacht waarschijnlijk aan het oude Griekenland. Maar dat is waar de EERSTE Spelen waren (776 v.Chr.), niet de moderne. Onthoud: lees precies welk woord in de vraag staat.",
          "2": "Je dacht waarschijnlijk aan 776 voor Christus. Maar dat is een datum, geen plaats. En het gaat om de oude Spelen, niet de moderne. Onthoud: de vraag is 'waar', niet 'wanneer'.",
          "3": "Je dacht waarschijnlijk aan 'om de vier jaar'. Maar dat is hoe vaak ze gehouden worden, niet waar ze begonnen. Onthoud: lees de vraag goed — er wordt naar een plaats gevraagd."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.confuses-old-and-modern", "label": "Verwart eerste en moderne Spelen", "optionIndex": 1 },
          { "id": "taa.wrong-question-type", "label": "Antwoordt met wanneer i.p.v. waar", "optionIndex": 2 },
          { "id": "taa.wrong-question-type", "label": "Antwoordt met hoe vaak i.p.v. waar", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-LEZEN-DETAIL-005",
      "familyId": "TAA-LEZEN-DETAIL",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tekstbegrip",
      "subSkill": "tekst_detail",
      "questionType": "fill_in",
      "question": "Hoeveel kan een blauwe vinvis wegen? Typ het getal en de eenheid (bijv. '150 ton').",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["150 ton", "meer dan 150 ton", "150ton", "ongeveer 150 ton", "150", "minstens 150 ton", "meer dan 150ton", "ruim 150 ton"],
        "caseSensitive": false,
        "placeholder": "... ton"
      },
      "stimulusAids": [
        {
          "type": "readingPassage",
          "data": {
            "passage": "De blauwe vinvis is het grootste dier dat ooit op aarde heeft geleefd. Een volwassen blauwe vinvis kan wel 30 meter lang worden en meer dan 150 ton wegen.",
            "instruction": "Lees de tekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Getal en eenheid aflezen",
            "content": "Zoek het sleutelwoord 'wegen' in de tekst. Lees het getal en de eenheid die erbij staan: 'meer dan 150 ton'. Typ het getal met de eenheid.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "detail_invullen",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Een blauwe vinvis kan meer dan 150 ton wegen. Dit staat letterlijk in de tekst. Bij detailvragen zoek je het exacte antwoord in de tekst.",
        "solutionSteps": [
          "Zoek in de tekst naar informatie over gewicht",
          "'meer dan 150 ton wegen'",
          "Antwoord: 150 ton (of meer dan 150 ton)"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "TAA-LEZEN-DETAIL-006",
      "familyId": "TAA-LEZEN-DETAIL",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tekstbegrip",
      "subSkill": "tekst_detail",
      "questionType": "text_highlight",
      "question": "Markeer het zinsdeel dat vertelt hoe oud de schildpad werd.",
      "data": {
        "text": "De reuzenschildpad Harriet leefde in een dierentuin in Australië. Ze werd maar liefst 176 jaar oud. Daarmee was ze een van de oudste dieren ter wereld.",
        "correctHighlights": [{ "start": 68, "end": 97 }]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Detailinformatie vinden",
            "content": "Bij een detailvraag zoek je het exacte antwoord in de tekst. Zoek het sleutelwoord uit de vraag ('oud') en markeer de zin of het zinsdeel waar dat antwoord staat.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "detail_highlight_leeftijd",
      "variantIndex": 6,
      "citoDifficulty": 0.27,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Het antwoord op 'hoe oud' staat in de tweede zin: 'Ze werd maar liefst 176 jaar oud.' Dit is de detailinformatie die je moet markeren.",
        "solutionSteps": [
          "Lees de vraag: hoe oud werd de schildpad?",
          "Zoek in de tekst naar leeftijdsinformatie",
          "'Ze werd maar liefst 176 jaar oud' → markeer dit"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "TAA-LEZEN-DETAIL-007",
      "familyId": "TAA-LEZEN-DETAIL",
      "module": "Taalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tekstbegrip",
      "subSkill": "tekst_detail",
      "questionType": "text_highlight",
      "question": "Markeer het woord dat vertelt welk dier het snelste landdier is.",
      "data": {
        "text": "De cheeta is het snelste landdier ter wereld. Dit roofdier kan snelheden van 120 kilometer per uur bereiken. Een cheeta kan echter maar 30 seconden zo hard rennen.",
        "correctHighlights": [{ "start": 3, "end": 9 }]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Sleutelwoord zoeken",
            "content": "Bij een detailvraag zoek je het sleutelwoord uit de vraag. Hier: 'snelste landdier'. Welk woord in de tekst beantwoordt die vraag?",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "detail_highlight_dier",
      "variantIndex": 7,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "De cheeta is het snelste landdier. Het woord 'cheeta' beantwoordt de vraag welk dier het snelste is.",
        "solutionSteps": [
          "Lees de vraag: welk dier is het snelst?",
          "Zoek in de tekst: 'De cheeta is het snelste landdier'",
          "Markeer 'cheeta'"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    }
  ]
}